import { Injectable } from '@angular/core';
declare let THREE: any;

@Injectable()
export class GhostObjectService {

  constructor() { }

  buildGhostObject(): any {
    var edges = new THREE.EdgesGeometry(new THREE.BoxBufferGeometry(1, 1, 1));

    var material = new THREE.LineBasicMaterial({
      color: 0x00ff00,
      depthTest: false,
      depthWrite: false
    });

    // THREE.LineSegments.call(this, edges, material);

    // this.name = "ghostObject";
    // this.renderOrder = 2;

    // this._lastScale = null;
    // this._cachedBoundingBox = null;

    let ghostObject = new THREE.LineSegments(edges, material);

    ghostObject.name = "ghostObject";
    ghostObject.renderOrder = 2;

    ghostObject._lastScale = null;
    ghostObject._cachedBoundingBox = null;

    ghostObject.geometry.computeBoundingBox();
    ghostObject.userData.boundingBox = ghostObject.geometry.boundingBox;

    return ghostObject;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/ghost-object.service.ts